<div class="page-header" id="banner">
  <div class="row">
    <div class="col">
      <h1>Fleet</h1>
    </div>
  </div>
</div>

<div class="card-columns">
  @for (vehicle of vehicles; track vehicle) {
    <app-vehicle-card [vehicle]="vehicle"></app-vehicle-card>
  }
  <a routerLink="/add-vehicle">
    <div class="card text-white bg-primary mb-3">
      <div class="card-body">
        <h5 class="card-title"><fa-icon [icon]="faPlus"></fa-icon></h5>
        <p class="card-text">Add a new vehicle.</p>
      </div>
    </div>
  </a>
</div>